/**
 * Append the 'px' suffix to the input value.
 */
function convertNumberToPx(value) {
    return value + 'px';
}
/**
 * Remove the 'px' suffix from the input value.
 */
function convertPxToNumber(value) {
    if (!value)
        return 0;
    return Number.parseInt(value.replace('px', ''));
}

/**
 * Calculate the top left position of the targetElement
 */
function extractElementPosition(document, targetElement) {
    let body = document.body;
    let docEl = document.documentElement;
    let windowPageYOffset = document.defaultView && document.defaultView.pageYOffset || undefined;
    let windowPageXOffset = document.defaultView && document.defaultView.pageXOffset || undefined;
    let scrollTop = windowPageYOffset || docEl.scrollTop || body.scrollTop;
    let scrollLeft = windowPageXOffset || docEl.scrollLeft || body.scrollLeft;
    let clientTop = docEl.clientTop || body.clientTop || 0;
    let clientLeft = docEl.clientLeft || body.clientLeft || 0;
    if (!targetElement) {
        // No element found, so return the current position to not cause any change in scroll position
        return { top: scrollTop, left: scrollLeft };
    }
    let box = targetElement.getBoundingClientRect();
    let top = box.top + scrollTop - clientTop;
    let left = box.left + scrollLeft - clientLeft;
    return { top: Math.round(top), left: Math.round(left) };
}

/**
 * Generated bundle index. Do not edit.
 */

export { convertNumberToPx, convertPxToNumber, extractElementPosition };

//# sourceMappingURL=ng-html-util.js.map